class PendientesItemsService {
  constructor ($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
  }
  
  getBranchesByThirdId(thirdId) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + '/user/third-center-operating?thirdId=' + thirdId,
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

  getPendienteState(documentNumber, limit, page) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri2  + this.ngAuthSettings.config.paths.REPORTS.SYNC.PENDIENTES_ITEMS.LIST+
        '?terceroId=' + documentNumber +
        '&limit=' + limit +
        '&page=' + page,
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
  
  getPendienteStates(documentNumber, branchCode, limit, page, orderObject = null) {
    return this.$q((resolve, reject) => { 

      var orderColumn = orderObject !== null ? ('&typeOrder=' + orderObject.orderColumn) : '';
      var orderOrientation = orderObject !== null ? ('&orderOrientation=' + orderObject.orderOrientation) : '';

      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.SYNC.PENDIENTES_ITEMS.LIST +
        '?terceroId=' + documentNumber +
        '&sucursalCodigo=' + branchCode +
        '&limit=' + limit +
        '&page=' + page 
        + orderColumn
        + orderOrientation,
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }  

  getPendientesStatesBranches(documentNumber, branchCodes, fecha_ini, fecha_fin, limit, page) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.SYNC.PENDIENTES_ITEMS.LIST,
        data : {
          'documentoTercero' : documentNumber,
          'branchCode' : branchCodes,
          'fecha_ini' : fecha_ini,
          'fecha_fin' : fecha_fin,
          'limit' : limit,
          'page' : page
        },
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

  getExportExcel(pendientes,nameClient){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.SYNC.PENDIENTES_ITEMS.EXPORTEXCEL,
        data : {
          'pendientes' : pendientes,
          'nameClient': nameClient
        },
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

  getExportPdf(pendientes,nameClient){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.SYNC.PENDIENTES_ITEMS.EXPORT_PDF,
        data : {
          'pendientes' : pendientes,
          'client': nameClient
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded', 
          'Accept': 'application/pdf'
        },
        cache : false,
        responseType: "blob"
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

}

PendientesItemsService.$inject = ['$q','$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];

export default PendientesItemsService;



/** WEBPACK FOOTER **
 ** ./www/components/reports/pendientesItems/pendientes-items.service.js
 **/